import { EGroupedItemsType } from '~/src/services/properties';

export const blockGridColumnConfig = {
    label: {
        name: 'label',
        label: 'Заголовок',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            customStyles: {
                name: 'customStyles',
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                order: 4,
                withBreakpoints: true,
            },
            sortOrder: {
                name: 'sortOrder',
                label: 'Сортировка',
                type: EGroupedItemsType.String,
                order: 5,
                withBreakpoints: true,
            },
            background: {
                name: 'background',
                label: 'Фон',
                type: EGroupedItemsType.File,
                order: 3,
            },
            backgroundWebp: {
                name: 'webp',
                type: EGroupedItemsType.Hidden,
            },
            backgroundColor: {
                name: 'backgroundColor',
                label: 'Цвет фона:',
                type: EGroupedItemsType.ColorPicker,
            },
            paddingVertical: {
                name: 'paddingVertical',
                label: 'Вертикальный отступ',
                type: EGroupedItemsType.Margin,
                order: 2,
            },
            paddingHorizontal: {
                name: 'paddingHorizontal',
                label: 'Горизонтальный отступ',
                type: EGroupedItemsType.Margin,
                order: 2,
            },
            borderRadius: {
                name: 'borderRadius',
                label: 'Border Radius',
                type: EGroupedItemsType.Margin,
                order: 2,
            },
            width: {
                name: 'width',
                label: 'Ширина',
                type: EGroupedItemsType.Select,
                order: 3,
            },
            removeElement: {
                name: 'removeElement',
                label: 'Удалить колонку',
                type: EGroupedItemsType.ButtonRemove,
                order: 3,
            },
        },
    },
};
